export enum SelectedCandidatesFilter {
  ALL = 'all',
  CLOSED = 'closed',
  OPEN = 'open',
  SHORTLISTED = 'shortlisted',
}
